import { Box, Theme, useMediaQuery } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import React from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@icons/myicons/plus.svg?react";
import ArrowRiseIcon from "@icons/myicons/arrow-rise.svg?react";
import { MandatorType, useMandatorContext } from "@rentablo/theming";
import { AddPortfolio } from "@features/add/AddPortfolio";
import { AdaptiveButton, ResponsiveDropdown } from "@components";
import { useNewTransactionActions } from "./useNewTransactionActions";

const mandatorIconMap = {
  "kpmg-germany": <KeyboardArrowDownRoundedIcon />,
  default: <AddIcon width="18px" height="12px" />,
};

const getTransactionButtonIcon = (
  mandatorSlug: MandatorType
): React.ReactNode =>
  mandatorIconMap[mandatorSlug as keyof typeof mandatorIconMap] ||
  mandatorIconMap.default;

export const InvestmentsActions = () => {
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const { mandatorSlug } = useMandatorContext();
  const transactionActions = useNewTransactionActions();

  if (isSm) return null;

  const portfolioLabel = t("investmentsPage.header.actions.newDepot");
  const transactionLabel = t("investmentsPage.header.actions.main");

  return (
    <Box display="flex" flexDirection="row" gap={2}>
      <AddPortfolio
        id="new-portfolio-menu"
        mobileTitle={portfolioLabel}
        anchor={
          <AdaptiveButton
            icon={<ArrowRiseIcon width="18px" height="12px" />}
            label={portfolioLabel}
            testId="new-portfolio-button"
          />
        }
      />
      <ResponsiveDropdown
        id="new-transaction-menu"
        mobileTitle={transactionLabel}
        items={transactionActions}
        anchor={
          <AdaptiveButton
            icon={getTransactionButtonIcon(mandatorSlug)}
            label={transactionLabel}
            testId="new-transaction-button"
          />
        }
      />
    </Box>
  );
};
